import classNames from "classnames";
import { ButtonTemplate } from "../Templates";
import styles from "./Button.module.scss";
import React from "react";
function Button({ size, styleType, className, classNameContent, iconOnly, width, height, style, ...props }) {
    return (React.createElement(ButtonTemplate, { className: classNames(styles.btn, styles[`size-${size}`], styles[styleType], iconOnly && styles["icon-only"], className), classNameContent: classNames(styles.content, classNameContent), style: { height, width, ...style }, ...props }));
}
export default Button;
